import React from 'react';
import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { Controller } from 'react-hook-form';

const GenderRadioGroup = ({ control, defaultValue, rules, disabled, name }) => {
  const greenRadioStyle = {
    color: '#4caf50',
    '&.Mui-checked': {
      color: '#4caf50',
    },
  };

  return (
    <Box>
      <Typography variant='body1' sx={{ mb: 1 }}>
        Gender
      </Typography>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        render={({ field }) => (
          <RadioGroup row {...field} value={field.value || defaultValue}>
            <FormControlLabel
              value='M'
              control={<Radio sx={greenRadioStyle} />}
              label='Male'
              disabled={disabled}
            />
            <FormControlLabel
              value='F'
              control={<Radio sx={greenRadioStyle} />}
              label='Female'
              disabled={disabled}
            />
            <FormControlLabel
              value='O'
              control={<Radio sx={greenRadioStyle} />}
              label='Other'
              disabled={disabled}
            />
          </RadioGroup>
        )}
      />
    </Box>
  );
};

export default GenderRadioGroup;
